import { SmallText } from 'inpock-ui-react';

import * as S from './styled';

interface TableProps {
  tbody: {
    [key: string]: string | number;
  };
}

const TABLE_DICT: Record<string, string> = {
  company_name: '상호명',
  ceo_name: '대표자명',
  business_number: '사업자등록번호',
  location: '사업장 소재지',
  email: '이메일',
};

export function Table({ tbody }: TableProps) {
  return (
    <S.Table>
      <tbody>
        {Object.entries(tbody).map(([key, value]) => {
          // 통신판매업신고 정보를 완전히 제외
          if (key === 'online_sales_number') {
            return null;
          }

          return (
            <S.TableRow key={key}>
              <td>
                <SmallText className="text-gray-600 text-bold">
                  {TABLE_DICT[key as keyof typeof TABLE_DICT]}
                </SmallText>
              </td>
              <td>
                <SmallText className="text-gray-600">{value}</SmallText>
              </td>
            </S.TableRow>
          );
        })}
      </tbody>
    </S.Table>
  );
}
